export const ESCALATION_RULE_ADD_DATA = {
  ESCALATION_RULE_ADD_DATA_LOAD: "ESCALATION_RULE_ADD_DATA_LOAD",
  ESCALATION_RULE_ADD_DATA_SUCCESS: "ESCALATION_RULE_ADD_DATA_SUCCESS",
  ESCALATION_RULE_ADD_DATA_FAIL: "ESCALATION_RULE_ADD_DATA_FAIL",
  ESCALATION_RULE_ADD_DATA_RESET: "ESCALATION_RULE_ADD_DATA_RESET",
};

export const ESCALATION_RULE_POST_API = "tickets/escalation-rules"; // customize endpoint


// // Dropdown caching
// export const DROPDOWN_API = "/dropdown";  // base if needed (not mandatory)

export const DROPDOWN_CACHE = {
  DROPDOWN_CACHE_LOAD: "DROPDOWN_CACHE_LOAD",
  DROPDOWN_CACHE_SUCCESS: "DROPDOWN_CACHE_SUCCESS",
  DROPDOWN_CACHE_FAIL: "DROPDOWN_CACHE_FAIL",
};

export const RULE_LIST_API = "tickets/escalation-rules";
export const RULE_LIST_DELETE_API = "tickets/escalation-rules";
// Rule List
export const RULE_LIST = {
  RULE_LIST_LOAD: "RULE_LIST_LOAD",
  RULE_LIST_SUCCESS: "RULE_LIST_SUCCESS",
  RULE_LIST_FAIL: "RULE_LIST_FAIL",
  RULE_LIST_DELETE: "RULE_LIST_DELETE",
  RULE_LIST_DELETE_SUCCESS: "RULE_LIST_DELETE_SUCCESS",
  RULE_LIST_DELETE_FAIL: "RULE_LIST_DELETE_FAIL",
};


// API endpoints
export const CATEGORY_DROPDOWN_API = "tickets/categories/list";
export const STATUS_DROPDOWN_API = "tickets/ticket/statuses";
export const NOTIFICATION_VARIABLES_API = "tickets/notification-variables";

export const CATEGORY_DROPDOWN = {
  LOAD: "CATEGORY_DROPDOWN_LOAD",
  SUCCESS: "CATEGORY_DROPDOWN_SUCCESS",
  FAIL: "CATEGORY_DROPDOWN_FAIL",
};

export const STATUS_DROPDOWN = {
  LOAD: "STATUS_DROPDOWN_LOAD",
  SUCCESS: "STATUS_DROPDOWN_SUCCESS",
  FAIL: "STATUS_DROPDOWN_FAIL",
};

export const NOTIFICATION_VARIABLES = {
  LOAD: "NOTIFICATION_VARIABLES_LOAD",
  SUCCESS: "NOTIFICATION_VARIABLES_SUCCESS",
  FAIL: "NOTIFICATION_VARIABLES_FAIL",
};

// Example API endpoint:
export const ESCALATION_GET_DETAIL_API = "tickets/escalation-rules/";

export const ESCALATION_GET_DATA = {
  ESCALATION_GET_DATA_LOAD: "ESCALATION_GET_DATA_LOAD",
  ESCALATION_GET_DATA_SUCCESS: "ESCALATION_GET_DATA_SUCCESS",
  ESCALATION_GET_DATA_FAIL: "ESCALATION_GET_DATA_FAIL",
};

// Update escalation rule
export const ESCALATION_RULE_UPDATE_API = "tickets/escalation-rules/";

export const ESCALATION_RULE_UPDATE = {
  ESCALATION_RULE_UPDATE_LOAD: "ESCALATION_RULE_UPDATE_LOAD",
  ESCALATION_RULE_UPDATE_SUCCESS: "ESCALATION_RULE_UPDATE_SUCCESS",
  ESCALATION_RULE_UPDATE_FAIL: "ESCALATION_RULE_UPDATE_FAIL",
  ESCALATION_RULE_UPDATE_RESET: "ESCALATION_RULE_UPDATE_RESET",
};


// Escalation Rule Executions

export const ESCALATION_EXECUTIONS_GET_API = "tickets/escalation-rules/executions/query";
export const ESCALATION_EXECUTIONS_GET_ROW_COUNT_API = "tickets/escalation-rules/executions/rowcount";

export const ESCALATION_EXECUTIONS_GET = {
  ESCALATION_EXECUTIONS_GET_LOAD: "ESCALATION_EXECUTIONS_GET_LOAD",
  ESCALATION_EXECUTIONS_GET_SUCCESS: "ESCALATION_EXECUTIONS_GET_SUCCESS",
  ESCALATION_EXECUTIONS_GET_FAIL: "ESCALATION_EXECUTIONS_GET_FAIL",
  ESCALATION_EXECUTIONS_GET_ROW_COUNT: "ESCALATION_EXECUTIONS_GET_ROW_COUNT",
  ESCALATION_EXECUTIONS_GET_ROW_COUNT_SUCCESS: "ESCALATION_EXECUTIONS_GET_ROW_COUNT_SUCCESS",
  ESCALATION_EXECUTIONS_GET_ROW_COUNT_FAIL: "ESCALATION_EXECUTIONS_GET_ROW_COUNT_FAIL",
};




